import Unipage from "../templates/Unipage";

export default function Review() {

    return (<Unipage
        content={
            <>
                <h2>Review Project</h2>
                <p>
                    Reminder that, in general, <strong>it is NOT a good idea to make changes to your circuit while the Arduino is plugged in!!!!!!</strong>
                </p>
                <h3>Checkpoint A: Wire a Button</h3>

                <p>Our buttons are shaped like a spider. They have four legs. Each pair of legs is connected vertically. Pushing the button connects all four legs.</p>

                <p>The point of using a button is to detect a completed circuit created by pressing the button.</p>

                <h4>Wiring a Button</h4>
                <p>
                    <ol>
                        <li>Place the button on the breadboard</li>
                        <li>Connect one of the sides of the button to a power source, such as 5V</li>
                        <li>Connect the other side of the button to any digital pin.</li>
                        <li>Finally, add a resistor from the same side of the button to another part of the breadboard.</li>
                        <li>Connect the resistor to ground (GND).</li>
                    </ol>
                </p>

                <p>We will write code to monitor the signal on the digital pin. When we detect a spike in current, we will know that the button is pressed. When the button is released, the left over current will slowly dissipate through the resistor to ground. Thus, the digital pin will no longer detect any current and we will know in the code the button has been released.</p>

                <h4>Button Connection Diagram</h4>
                <p><img height="300 px" src="/arduino_imgs/button_sketch.jpg" /></p>

                <h4>Button Code</h4>
                <p>Button code generally uses an if statment. In the example above, the part inside the if statement with the double equal sign (==) is called the test.</p>
                <p>If the button is pressed when the code is run, it will print "Button pressed" to the Serial Monitor.</p>
                <p>The button pin is an INPUT from the Arduino's perspective because, in the code, we READ IN the current touching the pin.</p>

                <p><img height="300 px" src="/arduino_imgs/button_code.png" /></p>

                <h3>Checkpoint B: Controlling an LED</h3>

                <p>There are two main ways we can control a light-emitting diode or LED: by toggling a digital pin on and off OR by using a button to interrupt the power to the LED. We will use the first method in this example.</p>

                <h4>LED Connection Diagram</h4>
                <p>Remember, an LED must always be protected by a RESISTOR somewhere in the circuit.</p>

                <p>To wire the LED, connect the LONGER POSITIVE leg to a digital pin. Then connect the shorter negative leg to ground (GND).</p>

                <p><img height="300 px" src="/arduino_imgs/led_sketch.jpg" /></p>

                <h4>LED Control Code</h4>
                <p>Let's modify our button code to turn on/off the LED when pressed.</p>
                <p>We will need to add a new const int for the led control pin and set the pin mode. From the ARDUINO'S PERSPECTIVE, the control pin is an OUTPUT because it send power from the Arduino to the LED.</p>
                <p>Notice when the button is pressed we write HIGH (on) to the control pin. When the button isn't pressed, we need to make sure to turn the LED off by writing LOW (off) to the control pin.</p>

                <p><img height="400 px" src="/arduino_imgs/led_code.png" /></p>

                <h3>Checkpoint C: DJ Board</h3>

                <p>This checkpoint is a fun aside, that will show you how Arduino can help model real world systems. <strong>NO CODE REQUIRED.</strong></p>

                <p>Find the multi-color LED. It has 4 legs. The longest leg is the positive lead, and the other three are negative.</p>

                <h4>DJ Board Wiring Diagram</h4>
                <p>In the diagram, the longest leg of the multi-color LED acts as the positive lead.</p>
                <p><img height="300 px" src="/arduino_imgs/jamboard_sketch.jpg" /></p>


            </>
        }
    />);

}